import { useRef, useEffect, type JSX } from 'react';
import { useVideoPreviewStyles } from './videoPreview.styles';
import { useVideoElementPlayOnPause } from '../../../../../hooks/useVideoElementPlayOnPause';

type VideoPreviewProps = {
  videoEl?: HTMLVideoElement | HTMLElement;
  objectFit?: 'cover' | 'contain' | 'none';
  backgroundImage?: string;
  isBackgroundBlurry?: boolean;
};

export const VideoPreview = ({
  videoEl,
  objectFit = 'cover',
  backgroundImage,
  isBackgroundBlurry = false,
}: VideoPreviewProps): JSX.Element => {
  const videoContainerRef = useRef<HTMLDivElement>(null);

  const styles = useVideoPreviewStyles({
    videoEl,
    isBackgroundBlurry,
    objectFit,
    backgroundImage,
  });

  useVideoElementPlayOnPause(videoEl);

  useEffect(() => {
    if (videoEl === undefined) {
      return;
    }

    /**
     * Replaces the video element in the DOM if one exists already
     */
    videoContainerRef.current?.replaceChildren(videoEl);
  }, [videoEl]);

  return (
    <div
      ref={videoContainerRef}
      css={{
        ...styles.container,
        video: styles.video,
      }}
    />
  );
};
